import { render, staticRenderFns } from "./ImageScanUpload.vue?vue&type=template&id=4e1a7b4e&"
import script from "./ImageScanUpload.vue?vue&type=script&lang=js&"
export * from "./ImageScanUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports